import React from 'react';
import {Divider} from 'antd';
import {colors} from '../../theme';

interface SectionTitleProps {
  title: string;
  isSubtitle?: boolean;
}

const SectionTitle: React.FC<SectionTitleProps> = ({title, isSubtitle = false}) => {
  return (
    <Divider
      orientation="left"
      orientationMargin={0}
      style={{
        fontWeight: 600,
        fontSize: isSubtitle ? 16 : 18,
        marginBottom: 24,
        marginTop: 24,
        color: isSubtitle ? colors.textSecondary : colors.textPrimary,
      }}
    >
      {title}
    </Divider>
  );
};

export default SectionTitle;
